import {
  FDBodyText,
  FDIcon,
} from '@facet-wealth/design';
import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import {
  TimelineItem, TimelineConnector, TimelineSeparator, TimelineContent, TimelineOppositeContent,
} from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Timeline';
import PropTypes from 'prop-types';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('WelcomeToYourRoadmapTimelineItemLayou', (theme) => ({
  root: {
    flex: 0,
    paddingBottom: 0,
    margin: 0,
    minHeight: 0,
    gap: theme.spacing(3),
  },
}));

const Layout = ({ isLastSection }) => {
  const { resource } = useMetaLayoutContext();
  const theme = useTheme();
  const classes = useStyles(theme);

  if (!resource) {
    return null;
  }

  const value = resource.attr('value');
  const icon = resource.attr('icon');

  return (
    <TimelineItem className={classes.root} {...dataAttrs('welcome-to-your-roadmap-timeline-item')}>
      <TimelineOppositeContent style={{ display: 'none' }} />
      <TimelineSeparator>
        <FDIcon icon={icon} />
        {!isLastSection ? (
          <TimelineConnector
            style={{
              borderLeftColor: theme.palette.facet.oceana800,
              borderLeftStyle: 'dashed',
              borderLeftWidth: '1px',
              backgroundColor: theme.palette.facet.lightGray,
            }}
          />
        ) : null}
      </TimelineSeparator>
      <TimelineContent
        style={{
          paddingBottom: `${!isLastSection ? '24px' : '0px'}`,
          paddingTop: '0px',
          paddingLeft: '4px',
          paddingRight: '0px',
        }}
      >
        <FDBodyText value={value} {...dataAttrs('welcome-roadmap-timeline-item-content')} />
      </TimelineContent>
    </TimelineItem>
  );
};

Layout.defaultProps = {
  isLastSection: false,
};

Layout.propTypes = {
  isLastSection: PropTypes.bool,
};

export default Layout;
